import getters from './getters'

import i18n from '../../../i18n'

const state = {
    services: [
      {
        id: 1,
        step: 1,
        ref: i18n.t("services.ia.ref"),
        name: i18n.t("services.ia.name"),
        slug: i18n.t("services.ia.slug"),
        origami: 'penguin',
        excerpt: i18n.t("services.ia.excerpt"),
        desc: i18n.t("services.ia.desc"),
        tc1:  i18n.t("services.ia.tc-1"),
        tc2:  i18n.t("services.ia.tc-2"),
        tc3:  i18n.t("services.ia.tc-3"),
        color: i18n.t("services.ia.color"),
        quote: {
          author: i18n.t("services.ia.quote.author"),
          text: i18n.t("services.ia.quote.text"),
          authorDesc: i18n.t("services.ia.quote.authorDesc")
        }
      },
      {
        id: 2,
        step: 2,
        ref: i18n.t("services.front.ref"),
        name: i18n.t("services.front.name"),
        slug: i18n.t("services.front.slug"),
        origami: 'iceberg',
        excerpt: i18n.t("services.front.excerpt"),
        desc: i18n.t("services.front.desc"),
        tc1:  i18n.t("services.front.tc-1"),
        tc2:  i18n.t("services.front.tc-2"),
        tc3:  i18n.t("services.front.tc-3"),
        color: i18n.t("services.front.color"),
        quote: {
          author: i18n.t("services.front.quote.author"),
          text: i18n.t("services.front.quote.text"),
          authorDesc: i18n.t("services.front.quote.authorDesc")
        }
      },
        // {
        //   id: 3,
        //   step: 2,
        //   ref: i18n.t("services.accessibility.ref"),
        //   name: i18n.t("services.accessibility.name"),
        //   slug: i18n.t("services.accessibility.slug"),
        //   origami: i18n.t("services.accessibility.origami"),
        //   excerpt: i18n.t("services.accessibility.excerpt"),
        //   desc: i18n.t("services.accessibility.desc"),
        //   tc1:  i18n.t("services.accessibility.tc-1"),
        //   tc2:  i18n.t("services.accessibility.tc-2"),
        //   tc3:  i18n.t("services.accessibility.tc-3"),
        //   color: i18n.t("services.accessibility.color"),
        //   quote: {
        //     author: i18n.t("services.accessibility.quote.author"),
        //     text: i18n.t("services.accessibility.quote.text"),
        //     authorDesc: i18n.t("services.accessibility.quote.authorDesc")
        //   }
        // },
        // {
        //   id: 4,
        //   ref: i18n.t("services.ux.ref"),
        //   name: i18n.t("services.ux.name"),
        //   slug: i18n.t("services.ux.slug"),
        //   origami: i18n.t("services.ux.origami"),
        //   excerpt: i18n.t("services.ux.excerpt"),
        //   desc: i18n.t("services.ux.desc"),
        //   tc1:  i18n.t("services.ux.tc-1"),
        //   tc2:  i18n.t("services.ux.tc-2"),
        //   tc3:  i18n.t("services.ux.tc-3"),
        //   color: i18n.t("services.ux.color"),
        //   quote: {
        //     author: i18n.t("services.ux.quote.author"),
        //     text: i18n.t("services.ux.quote.text"),
        //     authorDesc: i18n.t("services.ux.quote.authorDesc")
        //   }
        // },
        // {
        //   id: 5,
        //   ref: i18n.t("services.banner.ref"),
        //   name: i18n.t("services.banner.name"),
        //   slug: i18n.t("services.banner.slug"),
        //   origami: i18n.t("services.banner.origami"),
        //   excerpt: i18n.t("services.banner.excerpt"),
        //   desc: i18n.t("services.banner.desc"),
        //   tc1:  i18n.t("services.banner.tc-1"),
        //   tc2:  i18n.t("services.banner.tc-2"),
        //   tc3:  i18n.t("services.banner.tc-3"),
        //   color: i18n.t("services.banner.color"),
        //   quote: {
        //     author: i18n.t("services.banner.quote.author"),
        //     text: i18n.t("services.banner.quote.text"),
        //     authorDesc: i18n.t("services.banner.quote.authorDesc")
        //   }
        // },
        {
          id: 6,
          step: 3,
          origami: 'lion',
          ref: i18n.t("services.legal.ref"),
          name: i18n.t("services.legal.name"),
          slug: i18n.t("services.legal.slug"),
          excerpt: i18n.t("services.legal.excerpt"),
          desc: i18n.t("services.legal.desc"),
          tc1:  i18n.t("services.legal.tc-1"),
          tc2:  i18n.t("services.legal.tc-2"),
          tc3:  i18n.t("services.legal.tc-3"),
          color: i18n.t("services.legal.color"),
          quote: {
            author: i18n.t("services.legal.quote.author"),
            text: i18n.t("services.legal.quote.text"),
            authorDesc: i18n.t("services.legal.quote.authorDesc")
          }
        }
      ]
  }
  
  export default {
    state,
    getters,
    // actions,
    // mutations
  }